<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="dollar-sign"/>
          {{ $t('referralReport') }}
        </h1>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-12">
          <div class="tile">
            <div class="form-inline">
              <client-select :model="filterFormModel"  attribute="client" @input="load" :isFilter="true" :place-holder="$t('selectClient')"
                             class="mr-1"></client-select>
              <time-range-picker :model="filterFormModel" @input="load" :label="$t('time')" :default-shortcut="8" class="mr-1"></time-range-picker>
              <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
              <button @click="reset" class="btn btn-secondary mr-1">Reset</button>
              <referral-export :data="data" :sum="sum" :avg="avg" :label="label"></referral-export>
            </div>
          </div>
          <div class="tile">
            <div class="table-responsive c-template-table">
              <table class="table table-hover table-bordered">
                <thead>
                <tr>
                  <th></th>
                  <th class="text-center">{{ $t('totalReferral') }}</th>
                  <th class="text-center">{{ $t('successReferral') }}</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr class="bg-success">
                  <td><b class="text-uppercase">{{ $t('totals') }}</b></td>
                  <td class="text-center"><span class="text-blue">{{ sum.total | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.success | numFormat }}</span></td>
                  <td></td>
                </tr>
                <tr class="bg-warning">
                  <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                  <td class="text-center"><span class="text-blue">{{ avg.total  | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.success  | numFormat }}</span></td>
                  <td></td>
                </tr>
                <tr :key="index" v-for="(item, index) in data">
                  <td style="min-width: 200px"><b>{{ label(item) }}</b></td>
                  <td class="text-center"><span class="text-blue">{{ item.total | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.success | numFormat }}</span></td>
                  <td class="text-center"><a href="javascript:" @click="detail(item, true)">{{$t('detail')}}</a></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal content-class="modal-content-2" header-bg-variant="white" hide-footer v-model="showDetail" size="lg" :title="detailTitle">
      <div class="row" v-if="!detailLoading || (detailItems && detailItems.length)">
        <div class="col-12">
          <div class="tile">
            <div class="form-inline">
              <form-select class="mr-1 mb-1" :model="detailFilterModel" attribute="status" :options="[
                  {value: null, text: $t('all')},
                  {value: 'success', text: $t('success')},
                  {value: 'failure', text: $t('failure')},
              ]"></form-select>
              <button @click="loadDetail" class="btn btn-primary mr-1 mb-1">{{$t('search')}}</button>
              <button @click="detailFilterModel.status = null" class="btn btn-secondary mr-1 mb-1">Reset</button>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="c-paging clearfix">
            <div class="c-paging__count" v-if="detailItemCount">
              {{$t('found', [detailItemCount])}}
            </div>
            <div class="c-paging__right">
              <div class="c-paging__numbers">
                <b-pagination v-if="detailItemCount > detailFilterModel.pageSize" class="pull-right" size="sm"
                              v-model="detailFilterModel.page" :total-rows="detailItemCount"
                              :per-page="detailFilterModel.pageSize" @input="loadDetail"></b-pagination>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" v-if="detailItems && detailItems.length">
          <div class="c-smart-table tile">
            <div class="row c-smart-table__title">
              <div class="col-lg-8">{{$t('client')}}</div>
              <div class="col-lg-4">{{$t('status')}}</div>
            </div>
            <div class="row" v-for="item in detailItems" :key="item._id">
              <div class="col-lg-8">
                <div>
                  <b>{{item.referred.companyName}}</b> <br>
                  <span class="font-italic">{{item.referred.domain}}</span>
                </div>
              </div>
              <div class="col-lg-4">
                <div>
                  <span class="badge badge-success" v-if="item.finishTime > 0">{{$t('success')}}</span>
                  <span class="badge badge-danger" v-else>{{$t('failure')}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-center text-danger" v-if="detailItems && !detailItems.length">
          <span v-if="detailFilterModel.page === 1 && !detailFilterModel.keyword">{{$t('notFoundCreate')}}</span>
          <span v-if="detailFilterModel.page > 1 || detailFilterModel.keyword">{{$t('notFoundSearch')}}</span>
        </div>
        <div class="col-12" v-if="detailItemCount">
          <div class="c-paging__count" v-if="detailItemCount">
            {{$t('found', [detailItemCount])}}
          </div>
          <b-pagination v-if="detailItemCount > detailFilterModel.pageSize" class="pull-right" size="sm"
                        v-model="detailFilterModel.page" :total-rows="detailItemCount" :per-page="detailFilterModel.pageSize"
                        @input="loadDetail">
          </b-pagination>
        </div>
      </div>
    </b-modal>
  </main>
</template>

<script>
import TimeRangePicker from "../../components/TimeRangePicker";
import moment from 'moment';
import ClientSelect from "../../components/ClientSelect";
import ReferralExport from "@/views/report/ReferralExport";

export default {
  components: {ClientSelect, TimeRangePicker, ReferralExport},
  data: function () {
    return {
      filterFormModel: {
        client: null,
      },
      loading: true,
      data: [],
      sum: {},
      avg: {},
      showDetail: false,
      detailTitle: '',
      detailLoading: false,
      detailFilterModel: {},
      detailItemCount: null,
      detailItems: [],
    }
  },
  methods: {
    load() {
      let loader = this.$loading.show();
      this.loading = true;
      this.$service.get('/report/referral', {
        params: this.filterFormModel
      }).then(response => {
        this.data = response.data;
        this.sum = {};
        this.avg = {};
        this.data.forEach(item => {
          item.total = item.new + item.user + item.extend + item.upgrade;
          for (let key in item) {
            if (!['label'].includes(key)) {
              item[key] = Math.abs(item[key]);
              if (!this.sum[key]) {
                this.sum[key] = 0;
              }
              this.sum[key] += Math.abs(item[key]);
            }
          }
        });
        for (let key in this.sum) {
          this.avg[key] = Math.round(this.sum[key] / this.data.length);
        }
      }).finally(() => {
        loader.hide();
        this.loading = false;
      });
    },
    label(item) {
      if (item.label) {
        return item.label;
      }
      if (!isNaN(item._id)) {
        if (this.filterFormModel.group === 'day') {
          return moment(item._id, 'x').format('ll');
        }
        if (this.filterFormModel.group === 'week') {
          return `${moment(item._id, 'x').format('ll')} --> ${moment(item._id, 'x').add(6, 'day').format('ll')}`;
        }
        if (this.filterFormModel.group === 'month') {
          return moment(item._id, 'x').startOf('month').format('MM/YYYY');
        }
      }
    },
    reset() {
      this.filterFormModel = {
        client: null
      };
      this.load()
    },
    detail(item) {
      this.showDetail = true;
      this.detailFilterModel = {
        page: 1,
        pageSize: 20,
        status: null,
        client: item._id,
      };
      this.detailTitle = this.$t('detailTitle', [item.label]);
      this.loadDetail()
    },
    loadDetail() {
      let loader = this.$loading.show();
      this.detailLoading = true;
      this.$service.get('/client-referral', {
        params: this.detailFilterModel
      }).then(response => {
        if (response.data) {
          this.detailItems = response.data.docs;
          this.detailItemCount = response.data.totalDocs;
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        this.detailLoading = false;
        loader.hide();
      });
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        referralReport: "Referral report",
        totalReferral: "Total referral",
        successReferral: "Success referral",
        detailTitle: "Clients referred by {0}",
        failure: "Failure"
      },
      vi: {
        referralReport: "Báo cáo giới thiệu",
        totalReferral: "Số lượt giới thiệu",
        successReferral: "Giới thiệu thành công",
        detailTitle: "Khách được giới thiệu bởi {0}",
        failure: "Chưa thành công"
      }
    }
  }
}
</script>
<style>
.modal-content-2 {
  background-color: #e5e5e5;
}
</style>